import { parseApplicationEnv } from './environment'

export { parseApplicationEnv } from './environment'
export let env: ReturnType<typeof parseApplicationEnv>

if (__DEV_SERVER__) env = parseApplicationEnv(import.meta.env)

export const initializeApplicationEnv = async () => {
	if (__DEV_SERVER__) return
	const response = await fetch('/config.json', { cache: 'no-store', credentials: 'omit', redirect: 'error' })
	if (!response.ok) throw new Error(`Unable to load application configuration: HTTP ${response.status}`)
	env = parseApplicationEnv(await response.json(), { release: true })
}
